import type {Block} from './DataLayoutTypes';

export interface DraggableBlock {
  block: Block;
  row: number;
  col: number;
}

/** Value-based equality check using row/col position, avoiding fragile reference identity. */
export function isSameDraggableBlock(a: DraggableBlock, b: DraggableBlock): boolean {
  return a.row === b.row && a.col === b.col;
}
